(function () {
    'use strict';
    var m = angular.module('policy');
    m.factory('policyPropertyIsOneToMany', ["policyPropertyToNodes", function (policyPropertyToNodes) {
        return function (properties, path) {
            var nodes = policyPropertyToNodes(path);
            return !!_(nodes).find(function (node) {
                return _(properties[node]).isObject() && properties[node].oneToMany;
            });
        };
    }]);
}());